/* Shared SVG gradient defs (ported from vault-app defs.txt) — mount once in the vault shell. */
const DEFS = `<svg width="0" height="0" style="position:absolute">
  <defs>
    <linearGradient id="gGold" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#F4DFAE"/><stop offset=".45" stop-color="#D9B366"/><stop offset="1" stop-color="#9C7434"/>
    </linearGradient>
    <linearGradient id="gRose" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#F6D3C4"/><stop offset=".5" stop-color="#DCA084"/><stop offset="1" stop-color="#A96B50"/>
    </linearGradient>
    <linearGradient id="gPlat" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#F2F3F5"/><stop offset=".5" stop-color="#C4C9CF"/><stop offset="1" stop-color="#8E959D"/>
    </linearGradient>
    <linearGradient id="gDia" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#FFFFFF"/><stop offset=".55" stop-color="#DCEBF5"/><stop offset="1" stop-color="#9FC3DC"/>
    </linearGradient>
    <linearGradient id="gEm" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#7FD6AC"/><stop offset="1" stop-color="#1D7A50"/>
    </linearGradient>
    <linearGradient id="gRuby" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#F0879B"/><stop offset="1" stop-color="#9E1B39"/>
    </linearGradient>
    <linearGradient id="gSap" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#7FA8E8"/><stop offset="1" stop-color="#1E3F8F"/>
    </linearGradient>
    <radialGradient id="bgWarm" cx=".5" cy=".38" r=".9">
      <stop offset="0" stop-color="#FBF7EE"/><stop offset="1" stop-color="#E9E2D2"/>
    </radialGradient>
    <radialGradient id="bgCool" cx=".5" cy=".38" r=".9">
      <stop offset="0" stop-color="#F4F7FA"/><stop offset="1" stop-color="#DCE3EA"/>
    </radialGradient>
    <radialGradient id="bgDark" cx=".5" cy=".4" r=".95">
      <stop offset="0" stop-color="#4A463E"/><stop offset="1" stop-color="#211F1B"/>
    </radialGradient>
    <linearGradient id="bgBlue" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#20344E"/><stop offset="1" stop-color="#101C2C"/>
    </linearGradient>
  </defs>
</svg>`;
export default function SvgDefs() {
  return <span aria-hidden dangerouslySetInnerHTML={{ __html: DEFS }} />;
}
